/**
 * Debug logging utility
 *
 * Logs are only output in development mode (NODE_ENV !== 'production').
 * In production builds, all debug calls are no-ops.
 *
 * Usage:
 *   import { debug } from '../utils/debug';
 *   debug.log('📊 [SystemSizes]', { pvKw, batteryKw });
 *   debug.warn('Warning message');
 *   debug.error('Error message');
 */

const isDev = process.env.NODE_ENV !== 'production';

export const debug = {
    log: (...args) => {
        if (isDev) console.log(...args);
    },
    warn: (...args) => {
        if (isDev) console.warn(...args);
    },
    error: (...args) => {
        // Always log errors, even in production
        console.error(...args);
    },
    info: (...args) => {
        if (isDev) console.info(...args);
    },
    table: (...args) => {
        if (isDev) console.table(...args);
    },
    group: (...args) => {
        if (isDev) console.group(...args);
    },
    groupEnd: () => {
        if (isDev) console.groupEnd();
    },
    time: (label) => {
        if (isDev) console.time(label);
    },
    timeEnd: (label) => {
        if (isDev) console.timeEnd(label);
    },
};

export default debug;
